(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bentleyjs_core"), require("geometry_core"));
	else if(typeof define === 'function' && define.amd)
		define("imodeljs_clients", ["bentleyjs_core", "geometry_core"], factory);
	else if(typeof exports === 'object')
		exports["imodeljs_clients"] = factory(require("bentleyjs_core"), require("geometry_core"));
	else
		root["imodeljs_clients"] = factory(root["bentleyjs_core"], root["geometry_core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__bentley_bentleyjs_core__, __WEBPACK_EXTERNAL_MODULE__bentley_geometry_core__) {
return 